module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroller-component"
  }, [_c('div', {
    staticClass: "scroller-mask",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.start($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.move($event)
      },
      "touchend": function($event) {
        $event.preventDefault();
        _vm.end($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scroller-indicator"
  }), _vm._v(" "), _c('div', {
    staticClass: "scroller-content",
    style: (_vm.style)
  }, _vm._l((_vm.dateList), function(i) {
    return _c('div', {
      staticClass: "scroller-item "
    }, [_vm._v(_vm._s(i.txt))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9399c242"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker.vue
// module id = 14
// module chunks = 0